import enUS from './en-US';

const localeLoaders = {
  da: () => import('./da'),
  de: () => import('./de'),
  'en-GB': () => import('./en-GB'),
  'es-CO': () => import('./es-CO'),
  'et-EE': () => import('./et-EE'),
  'fi-FI': () => import('./fi-FI'),
  'fr-FR': () => import('./fr-FR'),
  'hr-HR': () => import('./hr-HR'),
  'it-IT': () => import('./it-IT'),
  'lt-LT': () => import('./lt-LT'),
  'nl-NL': () => import('./nl-NL'),
  'no-NO': () => import('./no-NO'),
  'pl-PL': () => import('./pl-PL'),
  pt: () => import('./pt'),
  'ru-RU': () => import('./ru-RU'),
  'sv-SE': () => import('./sv-SE'),
  uk: () => import('./uk'),
  'ro-RO': () => import('./ro-RO'),
  'bg-BG': () => import('./bg-BG'),
};

export const loadLocale = async locale => {
  if (!locale || locale === 'en-US') {
    return enUS;
  }

  const loader = localeLoaders?.[locale];
  const localeModule = await loader?.();

  return localeModule?.default ?? enUS;
};

export default {
  'en-US': enUS,
};
